import { useEffect } from 'react';

import MyOrderBumps from 'pages/MyOrderBumps';
import OrderBumpForm from 'pages/OrderBumpForm';
import { PageNotFound } from 'pages/PageNotFound';
import { SelectAccount } from 'pages/SelectAccount';
import { useSelector } from 'react-redux';
import { Routes as RouterRoutes, Route, Navigate, useNavigate } from 'react-router-dom';
import { authService } from 'services';
import { selectUser } from 'store/selectors';
import { checkCookies } from 'utils/Cookies';

const Routes = () => {
  const navigate = useNavigate();
  const { accounts, id, userAccountSelected } = useSelector(selectUser);
  const idToAccess = authService.getUserIdCookie();

  useEffect(() => {
    if (accounts.length === 1 || userAccountSelected) {
      return;
    }

    if (!idToAccess && checkCookies()) {
      navigate(`selectaccount${window.location.search}`);
      return;
    }

    if (idToAccess !== id.toString()) {
      authService.switchAccount(Number(idToAccess));
    }
  }, [accounts.length, navigate, id, userAccountSelected, idToAccess]);

  return (
    <RouterRoutes>
      <Route path='/' element={<SelectAccount />} />
      <Route path='/orderbump' element={<MyOrderBumps />} />
      <Route path='/orderbump/:id' element={<OrderBumpForm />} />
      <Route path='/orderbump/create' element={<OrderBumpForm />} />
      <Route path='/404' element={<PageNotFound />} />
      <Route path='/selectaccount' element={<SelectAccount />} />
      <Route path='*' element={<Navigate to='/404' replace />} />
    </RouterRoutes>
  );
};

export default Routes;
